
import { EEcddAttachmentDocType, EEcddFormType } from '../enums/ecdd.enum';
import { ECDDFileModel } from '../models/ecdd.model';

export const EEcddFormTypeOrderIndividual = {
    [EEcddFormType.A1]: 1,
    [EEcddFormType.A3]: 2,
    [EEcddFormType.U1]: 3,
    [EEcddFormType.U3]: 4,
}

export const EEcddFormTypeOrderEntity = {
    [EEcddFormType.A2]: 1,
    [EEcddFormType.A4]: 2,
    [EEcddFormType.U2]: 3,
    [EEcddFormType.U4]: 4,
}

export const EEcddFormIndividualSet = new Set<string>(
    [
        EEcddFormType.A1,
        EEcddFormType.A3,
        EEcddFormType.U1,
        EEcddFormType.U3,
    ]);

export const EEcddFormEntitySet = new Set<string>(
    [
        EEcddFormType.A2,
        EEcddFormType.A4,
        EEcddFormType.U2,
        EEcddFormType.U4,
    ]);

export const EEcddMainCustomerSet = new Set<string>(
    [
        EEcddFormType.A1,
        EEcddFormType.U1,
        EEcddFormType.A2,
        EEcddFormType.U2,
    ]);

export const EEcddFormSupportDocumentsSet = new Set<string>(
    [
        EEcddAttachmentDocType.DOC_ID,
        EEcddAttachmentDocType.LETTER,
    ]);

export const EEcddFileAMLReportSet = new Set<string>(
    [
        EEcddAttachmentDocType.AML_REPORT,
    ]);

export const EEcddFileACRAReportSet = new Set<string>(
    [
        EEcddAttachmentDocType.ACRA_CERTIFICATE,
    ]);

export const EEcddFormMultipleSupportDocumentsSet = new Set<string>(
    [
        EEcddAttachmentDocType.SUPPORT_DOCUMENTS
    ]);

export const EEcddFormCheckListExcludeSet = new Set<string>(
    [
        ...EEcddFormSupportDocumentsSet,
        ...EEcddFormMultipleSupportDocumentsSet,
        ...EEcddFileAMLReportSet,
        ...EEcddFileACRAReportSet
    ]);

export type EEcddOwnerFiles = Record<string, { checklist: ECDDFileModel[], supportingDocumentsFormCAndU6: ECDDFileModel[], amlReport?: ECDDFileModel, isHideFilesSupportCAndU6?: boolean }>;

export const EEcddFilePriorApprovalSet = new Set<string>(
    [
        EEcddAttachmentDocType.C,
        EEcddAttachmentDocType.U6
    ]);